/**
 * i18n Configuration
 * 支援繁體中文 (zh-TW) 和英文 (en)
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// 引入語言資源
import commonZhTW from './locales/zh-TW/common.json';
import commonEn from './locales/en/common.json';
import authZhTW from './locales/zh-TW/auth.json';
import authEn from './locales/en/auth.json';
import dashboardZhTW from './locales/zh-TW/dashboard.json';
import dashboardEn from './locales/en/dashboard.json';
import projectZhTW from './locales/zh-TW/project.json';
import projectEn from './locales/en/project.json';
import projectBasicZhTW from './locales/zh-TW/projectBasic.json';
import projectBasicEn from './locales/en/projectBasic.json';
import userZhTW from './locales/zh-TW/user.json';
import userEn from './locales/en/user.json';
import organizationZhTW from './locales/zh-TW/organization.json';
import organizationEn from './locales/en/organization.json';
import methodologyZhTW from './locales/zh-TW/methodology.json';
import methodologyEn from './locales/en/methodology.json';
import validationZhTW from './locales/zh-TW/validation.json';
import validationEn from './locales/en/validation.json';
import passwordZhTW from './locales/zh-TW/password.json';
import passwordEn from './locales/en/password.json';
import baselineZhTW from './locales/zh-TW/baseline.json';
import baselineEn from './locales/en/baseline.json';
import settingsZhTW from './locales/zh-TW/settings.json';
import settingsEn from './locales/en/settings.json';
import pddZhTW from './locales/zh-TW/pdd.json';
import pddEn from './locales/en/pdd.json';
import paDescriptionZhTW from './locales/zh-TW/paDescription.json';
import paDescriptionEn from './locales/en/paDescription.json';
import sectionBZhTW from './locales/zh-TW/section_b.json';
import sectionBEn from './locales/en/section_b.json';
import sectionCZhTW from './locales/zh-TW/sectionC.json';
import sectionCEn from './locales/en/sectionC.json';
import sectionDZhTW from './locales/zh-TW/sectionD.json';
import sectionDEn from './locales/en/sectionD.json';
import sectionEZhTW from './locales/zh-TW/sectionE.json';
import sectionEEn from './locales/en/sectionE.json';
import sectionFZhTW from './locales/zh-TW/sectionF.json';
import sectionFEn from './locales/en/sectionF.json';
import paAppendixZhTW from './locales/zh-TW/paAppendix.json';
import paAppendixEn from './locales/en/paAppendix.json';
import systemCodeZhTW from './locales/zh-TW/systemCode.json';
import systemCodeEn from './locales/en/systemCode.json';
import methodologyExplanationZhTW from './locales/zh-TW/methodologyExplanation.json';
import methodologyExplanationEn from './locales/en/methodologyExplanation.json';
import reportManagerZhTW from './locales/zh-TW/reportManager.json';
import reportManagerEn from './locales/en/reportManager.json';

// 語言資源配置
const resources = {
  'zh-TW': {
    common: commonZhTW,
    auth: authZhTW,
    dashboard: dashboardZhTW,
    project: projectZhTW,
    projectBasic: projectBasicZhTW,
    user: userZhTW,
    organization: organizationZhTW,
    methodology: methodologyZhTW,
    validation: validationZhTW,
    password: passwordZhTW,
    baseline: baselineZhTW,
    settings: settingsZhTW,
    pdd: pddZhTW,
    paDescription: paDescriptionZhTW,
    sectionB: sectionBZhTW,
    sectionC: sectionCZhTW,
    sectionD: sectionDZhTW,
    sectionE: sectionEZhTW,
    sectionF: sectionFZhTW,
    paAppendix: paAppendixZhTW,
    systemCode: systemCodeZhTW,
    methodologyExplanation: methodologyExplanationZhTW,
    reportManager: reportManagerZhTW,
  },
  en: {
    common: commonEn,
    auth: authEn,
    dashboard: dashboardEn,
    project: projectEn,
    projectBasic: projectBasicEn,
    user: userEn,
    organization: organizationEn,
    methodology: methodologyEn,
    validation: validationEn,
    password: passwordEn,
    baseline: baselineEn,
    settings: settingsEn,
    pdd: pddEn,
    paDescription: paDescriptionEn,
    sectionB: sectionBEn,
    sectionC: sectionCEn,
    sectionD: sectionDEn,
    sectionE: sectionEEn,
    sectionF: sectionFEn,
    paAppendix: paAppendixEn,
    systemCode: systemCodeEn,
    methodologyExplanation: methodologyExplanationEn,
    reportManager: reportManagerEn,
  },
};

i18n
  // 偵測用戶語言
  .use(LanguageDetector)
  // 傳遞 i18n 實例給 react-i18next
  .use(initReactI18next)
  // 初始化 i18next
  .init({
    resources,
    fallbackLng: 'zh-TW', // 預設語言
    defaultNS: 'common', // 預設命名空間

    interpolation: {
      escapeValue: false, // React 已經處理 XSS
    },

    detection: {
      // 語言偵測順序
      order: ['localStorage', 'navigator'],
      // localStorage 的 key
      lookupLocalStorage: 'i18nextLng',
      // 快取用戶選擇的語言
      caches: ['localStorage'],
    },

    // 開發模式下顯示除錯訊息
    debug: import.meta.env.DEV,
  });

// 暴露 i18n 到 window 以便除錯
if (typeof window !== 'undefined') {
  (window as any).i18n = i18n;
}

export default i18n;
